import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-upload-pds-pru',
  standalone:false,
  templateUrl: './upload-pds-pru.component.html',
  styleUrl: './upload-pds-pru.component.scss'
})
export class UploadPdsPruComponent {
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: any;
  @Input() id: any;
  @Input() format: any;
  @Input() proposalId: any;
  @ViewChild('table') table!: Table;
  userID: any;
  baseUrl = environment.APIUrl;
  private subscriptions = new Subscription();
  docuemntList: any;
  winners:any;
  uploadedFiles: any[] = [];
  allDmsFiles: any[] = [];

  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private uploadService: UploadService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit() {
    this.getData();
  }
    toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
      basicInfo: false,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
  };    
  onDocumentUpload(data:any){
      console.log('>>>>data from upload', data);
      const formData = new FormData();
      formData.append('proposal_step',this.id);
      formData.append('name', data.name);
      formData.append('description', data.description);
      formData.append('file', data.file);
      // ✅ Use your service method here
      this.uploadService.uploadneedGenData(formData).subscribe({
        next:(res:any)=>{
          console.log('>>>>>>res need upload data',res);
        },
        error: (err) => {
          console.error('❌ Upload failed:', err);
        }
      });   
  }
  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);
    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }
    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);
        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);
    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res:any)=>{
          console.log('delete uploadData',res);
      },
      error: (err) => {
          console.error('❌ Upload failed:', err);
        }
    })
  }
    
  goToNextStep() {
    this.stepCompleted.emit();
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  editRow(row: any) {
    row.editing = true;
  }

  saveRow(row: any) {
    const formData = new FormData();

    // formData.append('document', row.documents);
 if (row.tempDocuments?.length) {
    row.tempDocuments.forEach((file: File) => {
      formData.append('document', file);
    });
  }

    const sub = this.apiService
      .putAPI(`/idex/upload/compliance/pds-pru/${row.id}/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => {},
      });
  }

  // onFileUpload(event: any, row: any, field: string) {
  //   const file = event.files[0];
  //   if (file) {
  //     // Normally send to backend and get fileId
  //     row[field] = file; // For now, just store name
  //     // console.log(`Uploaded ${field} for`, row.applicantName, ':', file.name);
  //   }
  // }

  // download(file: string, filename: string) {
  //   console.log('Downloading', file, 'as', filename);
  //  
  // }
getData() {
  let url = `/idex/upload/compliance/pds-pru/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`;
  const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
    this.docuemntList = resp;

    this.winners = resp.data.vendors.map((row: any) => {
      // map API "documents"
      row.documents = row.documents?.map((doc: any) => ({
        fileId: doc.document,
        fileName: doc.document.split('/').pop()
      })) || [];

      return row;
    });
  });
  this.subscriptions.add(sub);
}


// Robust handler for many possible event shapes

onMultipleFileUpload(event: any, row: any) {
  if (!row.tempDocuments) {
    row.tempDocuments = [];
  }

for (let file of event.files) {
    row.tempDocuments.push(file);
  }
}

removeFile(row: any, file: any) {
  row.documents = row.documents.filter((doc: any) => doc.fileId !== file.fileId);
  if (row.lastUploaded && row.lastUploaded.fileId === file.fileId) {
    row.lastUploaded = null;
  }
}
}